/**
 * @param   {object} state
 *
 * @returns {string}
 */
const getProfileTimezone = state => state.timezone

export default {
  getProfileTimezone
}
